import { Div2Floor } from "../utils/Div2Floor";
import {
  enumBoxHeightMode,
  enumBoxStyleSet,
  enumBoxWidthMode,
  enumChartBoxInteractionMode,
  enumChartElement,
  enumElementBorderStyle,
  enumFieldDisplayMode,
  enumWrapTextMode
} from "../constants";
import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { QBasePanel } from "./QBasePanel";
import { QBoxLayout } from "./QBoxLayout";
import { QChartBox } from "./QChartBox";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals";

export class QHoverPanel extends QBasePanel {
  constructor() {
    super();
    this.fSourcePanel = null;
    this.fWSMgr = null;
    this.fDisplayBox = null;
    this.fOnLeft = false;
    this.fSticky = false;

    this.fTargetBox = null;
    this.fStdHover = true;
  }

  InitHoverPanel(wsMgr, sourcePanel, pWidth, pHeight) {
    this.fSourcePanel = sourcePanel;
    this.fWSMgr = wsMgr;
    this.SizePanel(pWidth + 24, pHeight + 4);
    var wsMgr = this.fWSMgr;
    var aBox = new QChartBox();
    var l = this.GetHoverLayout(pWidth, pHeight);
    l.SetDocRef(wsMgr.GetDoc());
    aBox.InitChartBox(
      l,
      this,
      12,
      2,
      enumChartBoxInteractionMode.content,
      null,
      null,
      false,
      this.fWSMgr,
      false
    );
    this.fDisplayBox = aBox;
  }

  GetSticky() {
    return this.fSticky;
  }

  SetSticky(isSticky) {
    this.fSticky = isSticky;
  }

  PositionLeft(theBox) {
    var hoverWidth = this.GetWidth();
    var sp = this.fSourcePanel;
    var sf = sp.GetScaleFactor();
    var panX = sp.GetPanX() * sf;
    var sx = sp.GetPositionX();

    var cw = this.fWSMgr.GetCanvasWidth();
    var rightMax = cw - hoverWidth;

    var px = theBox.GetPositionX() + theBox.GetWidth();
    px = px * sf;
    px = px + sx;
    px = Math.floor(px - panX);
    if (px > rightMax) return true;

    return false;
  }

  ResetPanel() {
    this.fOffscreenBuffer = null;
    this.SizePanel(this.GetWidth(), this.GetHeight());
  }

  SetHoverTarget(theBox) {
    var toolMode = this.fWSMgr.GetToolMode();

    if (theBox != null && toolMode == "ToolMode1") {
      var sp = this.fSourcePanel;
      var sx = sp.GetPositionX();

      var px = theBox.GetPositionX();
      var w = theBox.GetWidth();
      var h = theBox.GetHeight();
      var py = theBox.GetPositionY() + Div2Floor(h);
      var sf = sp.GetScaleFactor();

      var curOnLeft = this.fOnLeft;
      this.fOnLeft = this.PositionLeft(theBox);
      var offset = 4 * sf;

      if (this.fOnLeft) offset = -offset - this.GetWidth();
      else px = px + w;

      if (curOnLeft != this.fOnLeft) this.ResetPanel();

      px = px * sf;
      py = py * sf;

      px = px + sx;
      py = py + sp.GetPositionY();

      var panX = sp.fPanX * sf;
      var panY = sp.fPanY * sf;
      px = Math.floor(px - panX);
      py = Math.floor(py - panY);

      var hpOffset = Div2Floor(this.GetHeight());

      this.PositionPanel(px + offset, py - hpOffset);
      this.SetTargetBox(theBox);
      this.SetShownState(true);
    } else this.SetShownState(false);
  }

  RenderBackground() {
    var b = this.fOffscreenBuffer;
    var ctx = b.getContext("2d");
    ctx.strokeStyle = "#DDDDDD";
    ctx.fillStyle = "#FFFFFF";

    var w = b.width;
    var h = b.height;

    ctx.lineWidth = 1;

    var t = ThicknessAdjuster(1);
    var triW = 10;
    var triH = 20;
    var triM = Div2Floor(triH);

    var sx = triW + t;
    var sy = 0 + t;
    var ex = w - sx;
    var ey = h - sy;

    var m = Div2Floor(h);
    ctx.beginPath();

    if (this.fOnLeft) {
      ctx.moveTo(sx, sy);
      ctx.lineTo(ex, sy);
      ctx.lineTo(ex, ey - m - triM);
      ctx.lineTo(ex + triW, ey - m);
      ctx.lineTo(ex, ey - m + triM);
      ctx.lineTo(ex, ey);
      ctx.lineTo(sx, ey);
      ctx.lineTo(sx, sy);
    } else {
      ctx.moveTo(sx, sy);
      ctx.lineTo(ex, sy);
      ctx.lineTo(ex, ey);
      ctx.lineTo(sx, ey);

      ctx.lineTo(sx, ey - m + triM);
      ctx.lineTo(sx - triW, ey - m);
      ctx.lineTo(sx, ey - m - triM);
      ctx.lineTo(sx, sy);
    }

    ctx.closePath();

    ctx.fill();
    ctx.stroke();
  }

  GetHoverLayout(width, height) {
    var boxStylesMgr = this.fWSMgr.GetBoxStylesMgr();
    var theLayout = null;

    if (boxStylesMgr != null) {
      var curSet = boxStylesMgr.CurrentBoxStyleSet();
      boxStylesMgr.SwitchBoxStyles(enumBoxStyleSet.sharedboxstyles);
      theLayout = boxStylesMgr.GetLayoutByName("Hover");
      boxStylesMgr.SwitchBoxStyles(curSet);
    }

    if (theLayout == null) {
      theLayout = new QBoxLayout();
      theLayout.InitBoxLayout(width, 2, 6);
      theLayout.SetWidthSizingMode(enumBoxWidthMode.fixedwidth);
      theLayout.SetHeightSizingMode(enumBoxHeightMode.fixedheight);
      theLayout.SetFixedHeight(height);
      var cW = theLayout.GetColWidth(1) - 88;
      theLayout.ResizeColumn(1, -cW, false);
      this.fStdHover = false;
    } else {
      this.fStdHover = true;
      theLayout = theLayout.Clone();
      theLayout.SetIsBoxStyle(false);
    }

    return theLayout;
  }

  GetTargetBox() {
    return this.fTargetBox;
  }

  SyncWithDBObj(dataObj, theLayout) {
    var n = theLayout.GetNumCells();
    for (var i = 0; i < n; i++) {
      var cellDesc = theLayout.GetIndexCellDesc(i);
      if (!cellDesc.IsFreeText()) {
        var fieldName = cellDesc.GetFieldSaveName();
        var fieldID = cellDesc.GetFieldSaveID();
        if (fieldName != null) {
          var aField = dataObj.GetFieldDefByID(fieldID);
          if (aField == null) aField = dataObj.GetFieldDefByName(fieldName);
          if (aField != null) cellDesc.SetField(aField);
        }
      }
    }
  }

  SetTargetBox(sourceBox) {
    if (sourceBox.GetDataObj() == null) return;

    this.fTargetBox = sourceBox;
    var dataObj = sourceBox.GetDataObj();
    var theLayout = this.fDisplayBox.GetLayout();
    theLayout.SetDBObj(dataObj);

    if (this.fStdHover) {
      this.SyncWithDBObj(dataObj, theLayout);
    } else {
      theLayout.SetBorderStyle(enumElementBorderStyle.noBorder);
      var f1 = dataObj.GetFieldDefByID("Name");
      var f2 = dataObj.GetFieldDefByID("Title");
      var f3 = dataObj.GetFieldDefByID("Phone");
      var f4 = dataObj.GetFieldDefByID("Mobile");
      var f5 = dataObj.GetFieldDefByID("Email");
      var f6 = dataObj.GetFieldDefByID("Photo");

      var c1 = theLayout.GetCellDesc(2, 1);
      c1.SetAlignment("left");
      c1.SetTextBold(true);
      c1.SetWrapText(enumWrapTextMode.unlimited);
      c1.SetFontColor("#35BDB2");

      var c2 = theLayout.GetCellDesc(2, 2);
      c2.SetAlignment("left");
      c2.SetWrapText(enumWrapTextMode.unlimited);

      var c3 = theLayout.GetCellDesc(2, 4);
      c3.SetAlignment("left");
      c3.SetWrapText(enumWrapTextMode.unlimited);
      c3.SetFieldDisplayMode(enumFieldDisplayMode.LabelAndField);
      c3.SetFontSize(10);

      var c4 = theLayout.GetCellDesc(2, 5);
      c4.SetAlignment("left");
      c4.SetWrapText(enumWrapTextMode.unlimited);
      c4.SetFieldDisplayMode(enumFieldDisplayMode.LabelAndField);
      c4.SetFontSize(10);

      var c5 = theLayout.GetCellDesc(2, 6);
      c5.SetAlignment("left");
      c5.SetWrapText(enumWrapTextMode.unlimited);
      c5.SetFieldDisplayMode(enumFieldDisplayMode.LabelAndField);
      c5.SetFontSize(10);

      var c6 = theLayout.GetCellDesc(1, 1);
      c6.SetAlignment("left");
      c6.SetPictureFrameHeight(100);
      c6.SetPictureFrameWidth(80);

      c1.SetField(f1);
      c2.SetField(f2);
      c3.SetField(f3);
      c4.SetField(f4);
      c5.SetField(f5);
      c6.SetField(f6);
    }

    this.fDisplayBox.ResetBoxLayout(false);
    //theLayout.CalculateLayout();
  }

  IsHoverHighlightEnabled() {
    return false;
  }

  GetBoxCmdCode() {
    return null;
  }

  DoHandleRightClick(hitElement, x, y) {
    var roMode = Globals._accountInfo.ReadOnlyMode();
    if (hitElement) {
      var isBox = this.IsElementChartBox(hitElement, true);
      if (!isBox) {
        var elementType = hitElement.GetElementType();
        //var eSelected = hitElement.IsSelected();
        if (elementType == enumChartElement.boxCell)
          if (roMode) {
            hitElement.CellHandleRightClick(x, y);
            return;
          }
      }
    }
  }
}
